import { AfterViewInit, Component, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { ResizedEvent } from 'angular-resize-event';
import { Social_Platform,
  Material_Design_Red, 
  Material_Design_Pink, 
  Material_Design_Purple, 
  Material_Design_Deep_Purple } from '../config/color-palettes';
import { DEFAULT_THEME as defaultTheme } from '@nebular/theme';

@Component({
  selector: 'nbx-waterfall',
  templateUrl: './waterfall.component.html',
  styleUrls: ['./waterfall.component.scss']
})
export class WaterfallEchartComponent implements AfterViewInit, OnChanges {
  @Input() resizable: boolean = true;
  autoResize = true;

  width: number;
  height: number;

  onResized(event: ResizedEvent) {
    this.width = event.newWidth;
    this.height = event.newHeight;
  }

  defaultThemeVariables = defaultTheme.variables;

  @Input() tooltipstr: string = '';
  @Input() legendstr: string = '';
  @Input() seriesstr: string = '';
  @Input() titlestr: string = '';
  @Input() gridstr: string = '';
  @Input() xaxisstr: string = '';
  @Input() yaxisstr: string = '';

  options: any = {};
  title: any;
  tooltip: any;
  legend: any;
  series: any;
  grid: any;
  xaxis: any;
  yaxis: any;

  ngAfterViewInit() {

    //Set Defaults
    this.title = (this.titlestr == '') ? {
      text: 'waterfall',
      subtext: 'Sub text',
      sublink: 'http://blank'
    } : JSON.parse(this.titlestr);

    this.tooltip = (this.tooltipstr == '') ? {
      trigger: 'axis',
      axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          type: 'shadow',        //'line' | 'shadow'
          label: {
            color: this.defaultThemeVariables.fgText,
            backgroundColor: this.defaultThemeVariables.tooltipBackgroundColor,
          },
      },
      formatter: function (params) {
          var tar = params[1];
          return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
      }
  } : JSON.parse(this.tooltip);

  this.legend = (this.legendstr == '') ? {
    orient: "horizontal", 
    data: ['Total Cost','Rent','Utilities','Transportation Costs','Meals','Number of Daily Necessities'],
    textStyle: {
      color: this.defaultThemeVariables.fgText,
    },
  } : JSON.parse(this.legendstr);

  this.grid = (this.gridstr == '') ? {
    left: '15%',
    right: '20%',
    bottom: '15%',
    containLabel: true
  } : JSON.parse(this.gridstr);

  this.xaxis = (this.xaxisstr == '') ? {
    type: 'category',
    // boundaryGap: false,
    splitLine: {show: false},
    data: ['Total Cost','Rent','Utilities','Transportation Costs','Meals','Number of Daily Necessities'],
  }: JSON.parse(this.xaxisstr);

  this.yaxis = (this.yaxisstr == '') ?
  {type: 'value'} : JSON.parse(this.yaxisstr);

  this.series = (this.seriesstr == '') ? 
    [
      {
          name: 'Aid',
          type: 'bar',
          stack: 'Total',
          itemStyle: {
              barBorderColor: 'rgba(0,0,0,0)',
              color: 'rgba(0,0,0,0)'
          },
          emphasis: {
              itemStyle: {
                  barBorderColor: 'rgba(0,0,0,0)',
                  color: 'rgba(0,0,0,0)'
              }
          },
          data: [0, 1700, 1400, 1200, 300, 0]
      },
      {
          name: 'Living Expenses',
          type: 'bar',
          stack: 'Total',
          label: {
              show: true,
              position: 'inside'
          },
          data: [2900, 1200, 300, 200, 900, 300]
      }
    ] : JSON.parse(this.seriesstr);

    this.options = {
      backgroundColor: "transparent",
      color: Object.values(Material_Design_Red),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      grid: this.grid,
      xAxis: this.xaxis,
      yAxis: this.yaxis,
      series: this.series
  };
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes)
    {
      if (changes.hasOwnProperty(propName))
      {
        switch(propName) {
          case 'tooltipstr': {
            console.log("tooltip update");
              this.updateOptions('tooltip',this.tooltipstr);
            break;     
          }
          case 'titlestr': {
            console.log("title update");
              this.updateOptions('title',this.titlestr);
            break;     
          }
          case 'legendstr': {
            console.log("legend update");
              this.updateOptions('legend',this.legendstr);
            break;
          }
          case 'seriesstr': {
            console.log("series update");
              this.updateOptions('series',this.seriesstr);
            break;
          }
          case 'xaxisstr': {
            console.log("xaxis update");
              this.updateOptions('xaxis',this.xaxisstr);
            break;
          }
          case 'yaxisstr': {
            console.log("yaxis update");
              this.updateOptions('yaxis',this.yaxisstr);
            break;
          }
          case 'gridstr': {
            console.log("grid update");
              this.updateOptions('grid',this.gridstr);
            break;
          }
        }
      }
    }

    this.options = {
      backgroundColor: 'transparent',
      color: Object.values(Material_Design_Pink),
      title: this.title,
      tooltip: this.tooltip,
      legend: this.legend,
      grid: this.grid,
      xAxis: this.xaxis,
      yAxis: this.yaxis,
      series: this.series
    }

  }

  private updateOptions(opt, value) {
    console.log(opt)
    console.log(value)
    this[opt] = JSON.parse(value);
    console.log(this.tooltip);

    this.options[opt] = this[opt];

    console.log(this.options);  
  }
}